import React from 'react';
import { createRoot } from 'react-dom/client';

import { DemarchesPermis } from '../main-app/components/DemarchesPermis';
import { SituationOption } from '../main-app/components/DemarchesPermis/types';

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('react-demarches-selector');

  if (!node) {
    return;
  }

  let options: SituationOption[] = [];

  try {
    options = JSON.parse(node.getAttribute('data-options') || '[]');
  } catch (error) {
    return;
  }

  if (!options.length) {
    return;
  }

  const root = createRoot(node);
  root.render(<DemarchesPermis options={options} />);
});
